import { Component, OnInit } from '@angular/core';
import { SessionStorageService } from '../session-storage.service';
import { LocalStorageKey } from '../models/storageKey';
import { UrlConfigService } from '../url-config.service';

@Component({
  selector: 'app-venue-confirmation',
  templateUrl: './venue-confirmation.component.html',
  styleUrls: ['./venue-confirmation.component.css']
})
export class VenueConfirmationComponent implements OnInit {
  venueName = '';
  email = '';
  contactUrl: string;

  constructor(
    private sessionStorage: SessionStorageService,
    private urlConfig: UrlConfigService
  ) {
    this.contactUrl = this.urlConfig.getMainWebsiteUrl();
  }

  ngOnInit(): void {
    // The session doc was deleted at submission; these were stashed in
    // localStorage by the review page purely for this copy.
    const storage = this.sessionStorage.getAllStorage();
    this.venueName = storage[LocalStorageKey.CONFIRMED_VENUE_NAME] || '';
    this.email = storage[LocalStorageKey.CONFIRMED_EMAIL] || '';
  }
}
